__turbopack_context__.v({
  "Arrow": "R7GJGG_Arrow",
  "ArrowFill": "R7GJGG_ArrowFill",
  "ArrowInnerStroke": "R7GJGG_ArrowInnerStroke",
  "ArrowOuterStroke": "R7GJGG_ArrowOuterStroke",
  "Avatar": "R7GJGG_Avatar",
  "Button": "R7GJGG_Button",
  "Fallback": "R7GJGG_Fallback",
  "Image": "R7GJGG_Image",
  "Item": "R7GJGG_Item",
  "NotificationsLabel": "R7GJGG_NotificationsLabel",
  "Popup": "R7GJGG_Popup",
  "Positioner": "R7GJGG_Positioner",
  "Separator": "R7GJGG_Separator",
  "SeparatorWrapper": "R7GJGG_SeparatorWrapper",
  "itemSub": "R7GJGG_itemSub",
  "link": "R7GJGG_link",
  "mobile": "R7GJGG_mobile",
  "notificationsCount": "R7GJGG_notificationsCount",
});
